import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { connect } from "react-redux";
import actions from "../../redux/groceryList/action";
import { serverResponse } from "../../util/fakeServer";
import { myGroceryListName, groceryListSentFlag } from "../../helper/constant";
import { language } from "../../languageProvider/language/language";
import { defaultLanguage } from "../../helper/utility";

const SentListModal = ({ isOpen, toggle, deleteAll }) => {
  const flyerCode = serverResponse.leaflet.code;
  const primary_color = serverResponse.config.primary_color;
  
  // Determina il tipo di invio (whatsapp o inshop)
  const sendType = serverResponse.config.send_grocery_list_data?.type || "inshop";

  const handleClearList = () => {
    // Svuota la lista (mygrcrlst{flyerId})
    deleteAll();
    // Rimuove il flag issended{flyerId}
    localStorage.removeItem(groceryListSentFlag + flyerCode);
    // Svuota anche il localStorage della lista
    localStorage.setItem(myGroceryListName + flyerCode, JSON.stringify([]));
    toggle();
  };

  // Funzione usata per chiusura modale (X, click esterno, pulsante Continua)
  const handleContinue = () => {
    // Rimuove solo il flag issended{flyerId}
    localStorage.removeItem(groceryListSentFlag + flyerCode);
    toggle();
  };

  const styles = {
    primaryBtn: {
      color: "white",
      backgroundColor: primary_color,
      borderColor: primary_color,
      width: "40%"
    },
    secondaryBtn: {
      color: primary_color,
      backgroundColor: "white",
      borderColor: primary_color,
      width: "40%"
    },
  };

  return (
    <Modal 
      isOpen={isOpen} 
      centered 
      className="delete-modalBlock"
      backdrop="static"
      keyboard={false}
    >
      <ModalHeader>
        {language[defaultLanguage].benvenuto_lista_gia_inviata || "Bentornato!"}
      </ModalHeader>
      <ModalBody>
        {language[defaultLanguage].benvenuto_lista_gia_inviata_messaggio || "Nella lista sono presenti dei prodotti. Vuoi lasciarli li o preferisci svuotarla?"}
      </ModalBody>
      <ModalFooter>
      <button
          className="btn"
          style={styles.primaryBtn}
          onClick={handleContinue}
        >
          {language[defaultLanguage].continua || "Continua"}
        </button>
        <button
          className="btn"
          style={styles.secondaryBtn}
          onClick={handleClearList}
        >
          {language[defaultLanguage].svuota_lista || "Svuota lista"}
        </button>
      </ModalFooter>
    </Modal>
  );
};

function mapDispatchToProps(dispatch) {
  return {
    deleteAll: () => {
      dispatch(actions.deleteAll());
    },
  };
}

export default connect(null, mapDispatchToProps)(SentListModal);
